export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10712.08eb4545.jpg";